import { motion, useInView } from "framer-motion"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"

const LegalContent = ({ module }) => {
  const ref = useRef(null)
  const sectionRef = useRef(null) // Ref for the section to scroll to
  const [hasPlayed, setHasPlayed] = useState(false)
  const isInView = useInView(ref)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }

  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }

  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  const [tab, setTab] = useState("tab-1")

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)
    const activeTab = queryParams.get("tab")
    if (activeTab === "privacy") {
      setTab("tab-2")
    } else {
      setTab("tab-1")
    }
    // Scroll to the section
    if (sectionRef.current) {
      sectionRef.current.scrollIntoView({ behavior: "smooth" })
    }
  }, [])

  const handleTabClick = (tabId, url) => {
    setTab(tabId)
    window.history.pushState({}, "", url)
  }

  if (module.hideSection === "no") {
    return (
      <React.Fragment>
        <motion.section
          ref={sectionRef} // Set the ref here
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className={`terms py-70 ${
            module.extraClass ? ` ${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          <motion.div
            ref={ref}
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className="container-fluid"
          >
            <motion.div
              variants={animFade}
              className="max-w-[1124px] mx-auto bg-white-200 pattern-ring-ribbon py-70 lgscreen:py-50 mdscreen2:py-45"
            >
              <div className="common-tabs container-fluid-lg">
                <div className="tabs-main">
                  <div className="tab-link-wrapper overflow-x-auto w-full">
                    {module?.tab && (
                      <ul className="flex justify-center items-center gap-x-25 tabs mdscreen:pt-15 mdscreen2:w-max mx-auto">
                        {module.tab.map((item, i) => {
                          const tabId = `tab-${i + 1}`
                          const url =
                            tabId === "tab-1"
                              ? "/terms-conditions/?tab=terms"
                              : "/terms-conditions/?tab=privacy"
                          return (
                            <li
                              key={i}
                              onClick={() => handleTabClick(tabId, url)}
                              className={`cursor-pointer text-black-100 border ${
                                tab === tabId ? "active-tab" : ""
                              }`}
                              onKeyDown={() => handleTabClick(tabId, url)}
                              aria-hidden="true"
                            >
                              {item.title}
                            </li>
                          )
                        })}
                      </ul>
                    )}
                  </div>
                  {module?.tab && (
                    <div className="tab-container pt-[30px] xlscreen:pt-[15px] mdscreen2:pt-[10px]">
                      {module.tab.map((item, k) => {
                        const tabId = `tab-${k + 1}`
                        return (
                          tab === tabId && (
                            <div key={k} className="content global-list !pt-0">
                              {parse(item.details)}
                            </div>
                          )
                        )
                      })}
                    </div>
                  )}
                </div>
              </div>
            </motion.div>
          </motion.div>
        </motion.section>
      </React.Fragment>
    )
  }
}

export default LegalContent
export const PageLegalContentFragment = graphql`
  fragment PageLegalContentFragment on WpPage_Pagecontent_PageContent_LegalContent {
    extraClass
    extraId
    hideSection
    tab {
      details
      title
    }
  }
`
